import { render, staticRenderFns } from "./PriceModule.vue?vue&type=template&id=949202dc&scoped=true"
import script from "./PriceModule.vue?vue&type=script&lang=ts"
export * from "./PriceModule.vue?vue&type=script&lang=ts"
import style0 from "./PriceModule.vue?vue&type=style&index=0&id=949202dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949202dc",
  null
  
)

export default component.exports